// extracted by mini-css-extract-plugin
module.exports = {"main":"UserRating_main__n2nIT","flat":"UserRating_flat__VqjDc"};